/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface WorkflowScript
 */
export interface WorkflowScript {
    /**
     *
     * @type {string}
     * @memberof WorkflowScript
     */
    workflowScriptId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowScript
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowScript
     */
    name?: string | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowScript
     */
    script?: string | null;
}

export function WorkflowScriptFromJSON(json: any): WorkflowScript {
    return WorkflowScriptFromJSONTyped(json, false);
}

export function WorkflowScriptFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowScript {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowScriptId': !exists(json, 'workflowScriptId') ? undefined : json['workflowScriptId'],
        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'script': !exists(json, 'script') ? undefined : json['script'],
    };
}

export function WorkflowScriptToJSON(value?: WorkflowScript | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowScriptId': value.workflowScriptId,
        'workflowId': value.workflowId,
        'name': value.name,
        'script': value.script,
    };
}

